// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"528de5b8","455":"6e201e4c","977":"fdc81462"}[chunkId] + ".chunk.js";
};